export default "__VITE_ASSET__niG7_Yv$__"